"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _web3CoreRequestmanager = require("web3-core-requestmanager");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var HttpRequestManager = /*#__PURE__*/function () {
  function HttpRequestManager(host, options) {
    _classCallCheck(this, HttpRequestManager);

    options = options || {};
    this.host = host;
    var config = {
      timeout: options.timeout || 15000,
      headers: {
        'Content-Type': 'application/json'
      }
    };

    if (options.headers) {
      options.headers.forEach(function (header) {
        config.headers[header.name] = header.value;
      });
    }

    this.request = _axios.default.create(config);
    return new _web3CoreRequestmanager.Manager(this);
  }

  _createClass(HttpRequestManager, [{
    key: "send",
    value: function send(payload, callback) {
      this.request.post(this.host, payload).then(function (result) {
        callback(null, result.data);
      }).catch(function (err) {
        callback(err);
      });
    }
  }, {
    key: "disconnect",
    value: function disconnect() {}
  }]);

  return HttpRequestManager;
}();

var _default = HttpRequestManager;
exports.default = _default;